import React from "react";
import AnimatedHeading from "../AnimatedHeading";
import { IMG } from "../../assetsBase";

const reasons = [
  {
    number: "01",
    icon: "icon7.png",
    title: "Tailored Solutions",
    description:
      "Every engagement is shaped around your goals, whether digital, business, or supply-driven.",
  },
  {
    number: "02",
    icon: "icon8.png",
    title: "Experienced Team",
    description:
      "Professionals across software, consulting, and international trade under one roof.",
  },
  {
    number: "03",
    icon: "icon7.png",
    title: "Trusted Global Network",
    description:
      "Reliable partnerships across regional and international markets you can depend on.",
  },
  {
    number: "04",
    icon: "icon7.png",
    title: "Reliable Delivery",
    description:
      "Consistent, quality-driven execution from first conversation to final delivery.",
  },
];

function WhyLozrian() {
  return (
    <section className="orbia-advance-sec pt-115 pb-80">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center mb-55">
              <span
                className="sub-title"
                data-aos="fade-down"
                data-aos-duration="1000"
              >
                Why Lozrian
              </span>
              <AnimatedHeading>
                One Partner. Multiple Solutions.
              </AnimatedHeading>
            </div>
          </div>
        </div>
        <div className="row">
          {reasons.map((reason, index) => (
            <div
              className="col-xl-3 col-md-6 col-sm-12"
              data-aos="fade-up"
              data-aos-duration={1000 + index * 200}
              key={reason.title}
            >
              <div className="orbia-iconic-box style-one mb-40">
                <div className="box-border"></div>
                <div className="icon-wrap">
                  <div className="number">{reason.number}</div>
                  <div className="icon">
                    <img src={`${IMG}/icon/${reason.icon}`} alt="icon" />
                  </div>
                </div>
                <div className="content">
                  <h4 className="title">{reason.title}</h4>
                  <p>{reason.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyLozrian;
